import { render, staticRenderFns } from "./FeaturedContent2.vue?vue&type=template&id=b0ee61c6"
import script from "./FeaturedContent2.vue?vue&type=script&lang=js"
export * from "./FeaturedContent2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
